var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-progress-linear", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.progressBar,
            expression: "progressBar"
          }
        ],
        attrs: { slot: "progress", color: "blue", indeterminate: "" },
        slot: "progress"
      }),
      _c("br"),
      _c(
        "span",
        { attrs: { title: _vm.msgAlert } },
        [
          _c("Alert", {
            attrs: { status: _vm.status, msg: _vm.msgAlert, id: "alertWarning" }
          }),
          _c("p", [
            _vm._v("Eleição: " + _vm._s(_vm.$store.state.vote.electionName))
          ]),
          _c("p", [
            _vm._v("Documento: " + _vm._s(_vm.$store.state.vote.identifier))
          ]),
          _c("p", [_vm._v("Nome: " + _vm._s(_vm.$store.state.vote.name))]),
          _c("p", [_vm._v("Data: " + _vm._s(_vm.$store.state.vote.votedOn))])
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _vm.bHidden ? _c("div", { staticClass: "col-1" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }